/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_SecondaryInputs */

const en_home_hero_cta_secondary = /** @type {(inputs: Home_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the guides`)
};

const ko_home_hero_cta_secondary = /** @type {(inputs: Home_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가이드 보기`)
};

const ja_home_hero_cta_secondary = /** @type {(inputs: Home_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドを見る`)
};

/**
* | output |
* | --- |
* | "Read the guides" |
*
* @param {Home_Hero_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_hero_cta_secondary = /** @type {((inputs?: Home_Hero_Cta_SecondaryInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_SecondaryInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_cta_secondary(inputs)
	if (locale === "ko") return ko_home_hero_cta_secondary(inputs)
	return ja_home_hero_cta_secondary(inputs)
});